import { render, staticRenderFns } from "./RegistroViajero.vue?vue&type=template&id=21249e0a&scoped=true"
import script from "./RegistroViajero.vue?vue&type=script&lang=js"
export * from "./RegistroViajero.vue?vue&type=script&lang=js"
import style0 from "./RegistroViajero.vue?vue&type=style&index=0&id=21249e0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21249e0a",
  null
  
)

export default component.exports